import React, { useCallback, useMemo } from 'react';

import LoadingButton from '../LoadingButton';

import './ActionButton.css';

const ActionButton = ({
  disabled = false,
  className = '',
  isDeleteButton = false,
  isSecondaryButton = false,
  leftIcon = null,
  LeftIconSvg = null,
  leftIconClassName = '',
  loading = false,
  noMargin = false,
  onClick = () => { },
  onSuccess = () => { },
  success = false,
  title = '',
}) => {
  const style = useMemo(() => {
    let styleName = 'Action-button';
    let styleNameText = '';

    if (isDeleteButton) {
      styleName = 'Action-button-red';
    }

    if (isSecondaryButton) {
      styleName = 'Action-button-white';
    }

    styleNameText = `${styleName}-text${disabled ? '-disabled' : ''}`;

    return {
      button: `${styleName} ${noMargin ? 'Action-button-no-margin' : ''}`,
      text: styleNameText,
    };
  }, [disabled, isDeleteButton, isSecondaryButton, noMargin]);

  const renderLeftIcon = useCallback(() => {
    if (LeftIconSvg) {
      return <LeftIconSvg />;
    }

    if (leftIcon) {
      return (
        <img alt="" className={leftIconClassName} src={leftIcon} />
      );
    }

    return null;
  }, [leftIcon, LeftIconSvg, leftIconClassName]);

  const text = useMemo(() => (
    <>
      {renderLeftIcon()}

      {title}
    </>
  ), [renderLeftIcon, title]);

  return (
    <LoadingButton
      className={`${style.button} ${className}`}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      onSuccessAnimationEnd={onSuccess}
      submit={false}
      success={success}
      text={text}
      textStyle={style.text}
    />
  );
};

export { ActionButton };
